import { Observer } from "mobx-react-lite";
import React from "react";
import joinClassName from "../../utils/className.utils";
import { useProps } from "../../utils/mobx.utils";
import { capitalizeFirstLetter } from "../../utils/string.utils";
import './CommandList.scss';
export var CommandList = function (props) {
    var p = useProps(props);
    return React.createElement(Observer, { children: function () {
            var columnAppearance = p.columnAppearance;
            return React.createElement("div", { className: joinClassName('CommandList', p.className, 'CommandList' + (capitalizeFirstLetter(p.direction || 'column')), columnAppearance, p.withBackground && 'withBackground') },
                React.createElement("div", { className: "CommandListInner" },
                    React.createElement("div", { className: "CommandListStartSlot" },
                        p.startSlot,
                        props.children || (!props.children && !p.endSlot && React.createElement("p", { className: "CommandListEmptyNotice" },
                            React.createElement("em", null, "No actions available")))),
                    p.endSlot && (React.createElement("div", { className: "CommandListEndSlot" }, p.endSlot))));
        } });
};
export default CommandList;
